import styles from "./Button.module.css"
const Button = (props) => {
  const { disabled, action, title} = props
  return (
    <button
      className={`${disabled ? styles.disabled_btn : styles.btn}`}
      onClick={action}
      disabled={disabled}
    >
      {title}
    </button>
  )
}

export default Button